import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import Settings from "../../../pages/Profile/Settings";
import { changePassword, cleanSettings, getPermissions, changePermissions, getPermissionType, loadNewPermission } from "../../../actions/profile";
import { SettingsContainerProps } from "../../../interfaces/containers";


function mapStateToProps(state: SettingsContainerProps) {
    return {
        fetchingChangePassword: state.profile.changePassword?.fetching,
        fetchingPermissions: state.profile.permissions.fetching,
        permissions: state.profile.permissions?.data,
        fetchingChangePermissions: state.profile?.changePermissions.fetching,
        fetchingPermissionType: state.profile.permissionsType?.fetching,
        permissionType: state.profile.permissionsType?.data,
        fetchingLoadNewPermission: state.profile.loadNewPermission?.fetching,
        changePassword: state.profile.changePassword?.data,
        getPermissions: state.profile.permissions,
        changePermissions: state.profile.changePermissions,
        getPermissionType: state.profile.permissionsType,
        loadNewPermission: state.profile.loadNewPermission
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        changePassword,
        cleanSettings,
        getPermissions,
        changePermissions,
        getPermissionType,
        loadNewPermission,
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);